__turbopack_context__.v({
  "panelHeaderItem": "DeliveryHeaderPanelItem-module__gyVdLW__panelHeaderItem",
  "panelHeaderItemActive": "DeliveryHeaderPanelItem-module__gyVdLW__panelHeaderItemActive",
});
